import React from "react";
import PropTypes from "prop-types";

function Button({ onClick, text, icon, outline, variant, type, ...rest }) {
    
    // Determine button class based on props
    const getButtonClass = () => {
        if (outline === true) {
            return "btn-outline";
        }
        if (variant === "inverse") {
            return "btn-primary-inverse";
        }
        return "btn-primary";
    };

    return (
        <>
            <button
                type={type ? type : "button"}
                className={`btn-class ${getButtonClass()}`}
                onClick={onClick}
                aria-live="polite"
                {...rest}
            >
                {rest.pageType === "reportSaving" ? (
                    <>
                        {text}
                        {icon && <i className={"fa-solid pl-10p " + icon}></i>}
                    </>
                ) : (
                    <>
                        {icon && <i className={"fa-solid pr-10p " + icon}></i>}

                        {text}
                    </>
                )}
            </button>
            <div
                aria-live="assertive"
                style={{ position: "absolute", height: 0, width: 0, overflow: "hidden" }}
            >
                {!rest.disabled && `${text} button is active`}
            </div>
        </>
    );
}

Button.propTypes = {
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string,
    icon: PropTypes.string,
    outline: PropTypes.bool,
    variant: PropTypes.oneOf(["default", "inverse"]),
    type: PropTypes.string
}

export default Button;
